var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._g(_vm._b({attrs:{"src":_vm.logoSrc,"alt":_vm.alt}},'img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }